/*
  平台配置模块：club/机构
  使用方法：
    第一步： 导入文件
        import mixinAppConfig from "@/mixin/mixinAppConfig";
    第二步： 使用文件
        export default {
          mixins: [mixinAppConfig],

          data() {
            return {
              // ...
            }
          }
        }
    第三步： 使用本模块变量/方法
 */
import storage from '@/utils/storage';
import { stageTypeList,stageTypeList_base, stageTypeListExtend } from "@/assets/js/yioksSelect";

// 注意这里的地址，是有问题的，但是不会影响正式环境；具体变量值请参考 ./yioksCOnfig.js
const baseUrlForBase = process.env.NODE_ENV === 'production' ? 'http://sfa.yioks.cn' : 'http://shanghaiqingxun2.devzz.yioks.org:2492';
const baseUrlForClub = process.env.NODE_ENV === 'production' ? 'http://sfaclub.yioks.cn' : 'http://shanghaiqingxun.devzz.yioks.org:2492';

export default {

  data() {
    return {

    }
  },

  computed: {
    // 判断平台类型 true:星级俱乐部； false:机构；
    isInClubSystem() {
      const clubConfig = this.$store.getters.sysHostType
      if(clubConfig === 'club') {
        return true
      } else {
         return false
      }
      // return false
    },
    // 是否可以进行增删改操作，目前专家这个角色 只能进行查看操作
    isCanEditData(){
      const role = this.$store.getters.roles
      if(['expert','organ'].includes(role)){
        return false
      }else{
        return true
      }
    },

    // 基本申报类型（星级俱乐部/机构用）
    stageTypeListForSelection() {
      const clubConfig = this.$store.getters.sysHostType
      if(clubConfig === 'club') {
        return stageTypeList
      } else {
         return stageTypeList_base
      }
    },

    // 基本申报类型（区体管搜索用）
    stageTypeListForYouthSearch() {
      const clubConfig = this.$store.getters.sysHostType
      if(clubConfig === 'club') {
        return stageTypeList.slice(0,1)
      } else {
         return stageTypeList_base
      }
    },

    // 基本申报类型（区体管搜索用/club专家也可用）
    stageTypeListForSystemSearch() {
      const clubConfig = this.$store.getters.sysHostType
      if(clubConfig === 'club') {
        // return stageTypeList.concat(stageTypeListExtend)
        return stageTypeListExtend
      } else {
         return stageTypeList_base
      }
    },

    // 区体管部门 搜索用默认值 呵呵，用不到了，哈哈哈
    defaultSelectStringForSearch() {
      const clubConfig = this.$store.getters.sysHostType
      if(clubConfig === 'club') {
        return ''
      } else {
         return ''
      }
    },
  },

  filters: {

    // 将俱乐部地址转化为机构地址 // 这个使用不方便，建议直接使用 yioksConfig.js中的方法；
    urlTransferToBase(val) {
      if(!val) {
        console.error('url can not be null')
        return
      }
      const transferedUrl = val.replace(baseUrlForBase, baseUrlForClub)
      return transferedUrl
    }
  },
}
